export enum HrEmployeeLeaveModalMode {
  VIEW = "view",
  EDIT = "edit",
}
